import classes from './HomeIcon.module.scss';

export default function HomeIcon() {
  return (
    <svg
      className={classes.homeIcon}
      fill="none"
      height="24"
      viewBox="0 0 38 38"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={
          'M20.1964 0.473613C19.5186 -0.157871 18.4756 -0.157871 17.7988 0.473613L0.569775 16.546C0.206496 16.8845 0 17.3612 0 17.8612V36.211C0 37.1983 0.791567 38 1.7686 38H13.754V27.8044C13.754 24.8742 16.1 22.5011 18.9976 22.5011C21.8952 22.5011 24.2403 24.8742 24.2403 27.8044V38H36.2314C37.2084 38 38 37.1983 38 36.211V17.8612C38 17.3612 37.7935 16.8845 37.4302 16.546L20.1964 0.473613Z'
        }
        fill="white"
      />
    </svg>
  );
}
